/*
* If an active project has been set, redirects to project takeoff
* otherwise redirect to project list.
*/
<template lang="pug">
	p
</template>
<script>
import {mapState} from 'vuex'
import _ from 'lodash'
import store from 'CommonApp/store'

export default {
	name: 'active-project',
	computed: {
		...mapState({
			activeProject: state => state.activeProject
		})
	},
	beforeMount () {
		store.dispatch({
			type: 'initialiseStore',
			value: ''
		})

		if (!_.isNil(this.activeProject) && this.activeProject !== '') {
			this.$router.push({name: 'project.takeoff', params: {id: this.activeProject}})
		} else {
			this.$router.push({name: 'project.list'})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/project/active-project.vue